import React from 'react';

import api     from '../../../../../../../api';
import values  from '../../../../../../../values';
import Context from '../../../../../../../context';

import WithdrawalDriverScreen from '..';

import { TModal              } from '../../../../../../../types/common.type';
import { useQuery            } from 'react-query';
import { IWithdrawalFind     } from '../../../../../../../types/common.interface';
import { WithdrawalNamespace } from '../../../../../../../types/withdrawal.namespace';
import {getWithdrawalDriver} from "../../../../../../../values/useQueryKeys";

const DriverWithdrawalContainer: React.FC = (): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const [showModal, setShowModal] = React.useState<TModal>('NONE');
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [selectedWithdrawal, setSelectedWithdrawal] = React.useState<string>('');
  const [selectedWithdrawals, setSelectedWithdrawals] = React.useState<string[]>([]);
  const [requestWithdrawal, setRequestWithdrawal] = React.useState<IWithdrawalFind>({
      page: 1,
      sort: 'CREATED_AT',
      limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
      filters: {type: 'DRIVER'},
    });

  const UpdateOneApis: WithdrawalNamespace.updateOneFunctions = {
    ACCEPT     : api.put.common.withdrawalAcceptOne   ,
    REJECT     : api.put.common.withdrawalRejectOne   ,
    SEND_2_BANK: api.put.common.withdrawalSend2BankOne,
  }

  const UpdateManyApis: WithdrawalNamespace.updateManyFunctions = {
    ACCEPT     : api.put.common.withdrawalAcceptMany   ,
    REJECT     : api.put.common.withdrawalRejectMany   ,
    SEND_2_BANK: api.put.common.withdrawalSend2BankMany,
  }

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // ! =================================================================================================================
  // ! ------------------------------------------------ Start Call API -------------------------------------------------

  // ? Panel-wide academic year (سال تحصیلی). It has to be in the query key as well as the request, otherwise
  // ? react-query serves the previous year's cached rows when the year is switched.
  const { selectedYear } = React.useContext(Context.AcademicYear);

  const getAllWithdrawal = useQuery(
    [values.useQueryKeys.getWithdrawalDriver, requestWithdrawal, selectedYear?._id],
    () => api.post.common.findWithdrawal({ ...requestWithdrawal, academicYear: selectedYear?._id })
  );

  // ! ------------------------------------------------- End Call API --------------------------------------------------
  // ! =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  async function withdrawalUpdateOne(props: WithdrawalNamespace.updateOne): Promise<void> {
    setIsLoading(true);
    await UpdateOneApis[props.type]({withdrawalId: props._id, description: props.description});
    await getAllWithdrawal.refetch();
    setIsLoading(false);
  }

  async function withdrawalUpdateMany(props: WithdrawalNamespace.updateMany): Promise<void> {
    setIsLoading(true);
    await UpdateManyApis[props.type](props.ids);
    await getAllWithdrawal.refetch();
    setIsLoading(false);
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <Context.WithdrawalScreen.Provider value={{
      isLoading          ,
      showModal          ,
      getAllWithdrawal   ,
      requestWithdrawal  ,
      selectedWithdrawal ,
      selectedWithdrawals,
      setShowModal          ,
      withdrawalUpdateOne   ,
      withdrawalUpdateMany  ,
      setRequestWithdrawal  ,
      setSelectedWithdrawal ,
      setSelectedWithdrawals,
    }}>
      <WithdrawalDriverScreen resultRequestWithdrawal={getAllWithdrawal} />
    </Context.WithdrawalScreen.Provider>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================
}

export default DriverWithdrawalContainer;
